import React from "react";
import EventOccurrenceInformation from "../../../stores/domainStore/pages/models/eventOccurrenceInformation";
import ModalDetailContent from "../../molecules/modalDetailContent/modalDetailContent";
import {IconSource} from "../../../shared/enums/iconSource";
import {observer} from "mobx-react-lite";
import {format} from "date-fns";
import {utcToZonedTime} from "date-fns-tz";
import "./eventOccurrencesList.sass";
import {Col, Row} from "reactstrap";

export interface IEventOccurrencesListProps {
  eventOccurrences: EventOccurrenceInformation[];
  onEditClick: (occurrenceDate: Date) => void;
  timeZone: string;
}

const EventOccurrencesList: React.FC<IEventOccurrencesListProps> = ({
  eventOccurrences,
  onEditClick,
  timeZone
}) => {
  const items = eventOccurrences.map((eventOccurrence) => (
    <div
      className="occurrence-modal-detail"
      key={eventOccurrence.occurrenceDate.toISOString()}
    >
      <ModalDetailContent
        icon={IconSource.recent}
        isCentred={false}
        children={
          <div>
            <Row>
              <Col xs="auto" className="occurrence-date-label">
                <div data-testid="occurrenceDateLabel">
                  {format(
                    utcToZonedTime(eventOccurrence.occurrenceDate, timeZone),
                    "EEEE, dd MMMM yyyy"
                  )}
                </div>
              </Col>
              <Col className="edit-bookings-button">
                <div
                  onClick={() => onEditClick(eventOccurrence.occurrenceDate)}
                >
                  Edit
                </div>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  ));
  return (
    <div
      className="occurrences-list-scrollable"
      data-testid="eventOccurrencesList"
    >
      {items}
    </div>
  );
};

export default observer(EventOccurrencesList);
